import { Injectable } from '@angular/core';

import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

import { CacheService } from '../services/cache.service';

import { CacheKey } from '../constants/cachekey.constants';

@Injectable()
export class FeatureCanActivateGuard implements CanActivate {

    constructor(private _authService: AuthService,
        private _router: Router, private _cacheService: CacheService) {

    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Promise<boolean> {
        // console.log(route.data['privileges']);
        let hasAccess = true;
        await this._authService.hasPrivilege(route.data['privileges'])
            .then((res) => {
                hasAccess = true;
            });
        return new Promise<boolean>((resolve, reject) => {
            if (!hasAccess) {
                this.redirectToNotFoundPage(state.url);
            }
            resolve(hasAccess);
        });
    }

    redirectToNotFoundPage(returnUrl: string) {
        let isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
        let languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
        this._router.navigate(['/' + isoCountryCode.toLowerCase() + '/' + languageCode.toLowerCase() + '/notfound',
        { skipLocationChange: true, queryParams: { returnUrl: returnUrl } }]);
    }
}